import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Quiniela } from 'src/app/models/quiniela';
import { QuinielasService } from 'src/app/services/quinielas.service';
import { Jugador } from 'src/app/models/jugador';
import { JugadorService } from 'src/app/services/jugadores.service';
import { AuthService } from 'src/app/services/auth.service';
import { AdminService } from 'src/app/services/admin.service';
import { Admin } from 'src/app/models/admin';
import { User } from 'firebase';
import { TablaService } from 'src/app/services/tabla.service';
import { Tabla } from 'src/app/models/tabla';


@Component({
  selector: 'app-jugadores-page',
  templateUrl: './jugadores-page.component.html',
  styleUrls: ['./jugadores-page.component.css']
})
export class JugadoresPageComponent implements OnInit {
  quiniela: Quiniela;
  jugadores: Array<Jugador> = [];
  isLoading = true;
  user: User = null;
  isAuthenticated = false;
  admins: Array<Admin> = [];

  constructor(
    private rutaActiva: ActivatedRoute,
    private QuinielasService: QuinielasService,
    private JugadoresService: JugadorService,
    private authService: AuthService,
    private JugadorService: JugadorService,
    private router: Router,
    private AdminService: AdminService,
    private TablaService: TablaService,
  ) { }



  ngOnInit(): void {
    // Obtener por parametro de URL el ID de la Quiniela
    var idQuiniela = this.rutaActiva.snapshot.params.id;
    console.log(idQuiniela)

    // Obtener la Quiniela con ese ID mediante el Servicio
    this.QuinielasService.getQuiniela(idQuiniela).subscribe((item) => {
      this.quiniela = {
        $key: item.payload.id,
        ...item.payload.data(),
      };
      // Imprimiendo la Quiniela
      console.log(this.quiniela)

      this.getCurrentUser();

      // Cambiar el estado de Cargando
      this.isLoading = false;
      // Buscarlos los Jugadores
      this.getAllJugadores()
    });
  }

  getCurrentUser(): void {
    this.authService.getCurrentUser().subscribe((response) => {
      if (response) {
        this.user = response;
        this.isAuthenticated = true;

        this.AdminService.getAdmin(this.user.email).subscribe((items) => {
          // Setting up admins
          this.admins = items.map(
            (item) =>
            ({
              ...item.payload.doc.data(),
              $key: item.payload.doc.id,
            } as Admin)
          );
          console.log(this.admins)
          if (this.quiniela.user != this.user.email && this.admins.length == 0) {
            this.router.navigate(['/quinielas']);
          }

        });
        return;
      }
      this.isAuthenticated = false;
    });
  }

  getAllJugadores(): void {
    this.isLoading = true;
    this.JugadoresService.getAllJugadoresByIdQuiniela(this.quiniela.$key).subscribe((items) => {
      // Setting up jugadores
      this.jugadores = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as Jugador)
      );
      // Imprimiendo los Jugadores de la Quieniela
      console.log(this.jugadores)
      // Variable de cargando
      this.isLoading = false;
    });
  }

  Desactivar(jugador: Jugador) {
    jugador.confirmado = false
    this.JugadoresService.updateJugador(jugador, jugador.$key).then((res) => { });

    this.calcularPote();
    this.generarTabla();
  }

  Activar(jugador: Jugador) {
    jugador.confirmado = true
    this.JugadoresService.updateJugador(jugador, jugador.$key).then((res) => { });

    this.calcularPote();
    this.generarTabla();
  }

  generarTabla() {
    // Se obtienen todos los juagadores para generar Objeto con todos los jugadores para que sean menos lecturas
    var jugadores: Array<Jugador> = [];
    const jugadoresServiceSubs = this.JugadoresService.getAllJugadoresByIdQuiniela(this.quiniela.$key).subscribe((items) => {
      // Setting up jugadores
      jugadores = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as Jugador)
      );
      jugadoresServiceSubs.unsubscribe();

      console.log(jugadores)
      // Filtrar jugadores confirmados
      var jugadoresActivos = [];
      for (let jugador of jugadores) {
        if (jugador.confirmado) {
          jugadoresActivos.push(jugador);
        }
      }
      jugadores = jugadoresActivos;
      //Armando objeto para la coleccion data tabla
      const dataTabla: Tabla = {
        idQuiniela: this.quiniela.$key,
        tabla: jugadores,
      };

      // Obtener la tabla a partir de un ID o $Key de la tabla
      const tablaServiceSub = this.TablaService.getAllTablasByIdQuiniela(this.quiniela.$key).subscribe((items) => {
        var tabla = items.map(
          (item) =>
          ({
            ...item.payload.doc.data(),
            $key: item.payload.doc.id,
          } as Tabla)
        );
        tablaServiceSub.unsubscribe();

        // Si la loongitud de la peticion a DB es diferente a 0 significa que si existe esa tabla en DB 
        if (tabla.length != 0) {
          // Envia a actualizar
          this.TablaService.updateTabla(dataTabla, tabla[0].$key).then((res) => {
            console.log("SE ACTUALIZO LA TABLA DE LA QUINIELA.")
          });
        } else {
          // Envia a crear la tabla
          this.TablaService.createTabla(dataTabla).then((res) => {
            console.log("SE CREO LA TABLA DE LA QUINIELA.")
          });
        }
      });
    });
  }

  calcularPote() {
    var jugadores: Array<Jugador> = [];
    this.JugadorService.getAllJugadoresByIdQuiniela(this.quiniela.$key).subscribe((items) => {
      // Setting up jugador
      jugadores = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as Jugador)
      );

      // Filtar que sean solo jugadores confirmados
      let jugadoresConfirmados = [];
      for (const jugador of jugadores) {
        if (jugador.confirmado) {
          jugadoresConfirmados.push(jugador);
        }
      }

      // Calcular cuanto es el pote
      var totalJugadores = jugadoresConfirmados.length;
      var precioQuiniela = this.quiniela.precio;
      var porcentajePote = this.quiniela.porcentaje;

      var pote = ((totalJugadores * precioQuiniela) * porcentajePote) / 100;

      this.quiniela.pote = pote;

      this.QuinielasService.updateQuiniela(this.quiniela, this.quiniela.$key).then((res) => {
        console.log("Se ha editado con exito el pote de la Quiniela");
      });

    });
  }

  buscar() {
    console.log("asd")
    var input, filter, table, tr, td, i, txtValue;
    input = document.getElementById("buscarInput");
    filter = input.value.toUpperCase();
    table = document.getElementById("table");
    tr = table.getElementsByTagName("tr");
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[0];
      if (td) {
        txtValue = td.textContent || td.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }
    }
  }

}
